import * as core from '../../../../../../../core'
import * as proposalStatus from '../proposal-status'

export const RESOURCE = {
  payload: {
    description: '4. Capability Lead Review',
    enumId: core.dms.models.Enum.Id.from({
      partialId: proposalStatus.RESOURCE.payload.partialId,
    }),
    id: '4. Capability Lead Review',
    name: '4. Capability Lead Review',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
